import { render, staticRenderFns } from "./OrderChangeStatusDispatched.vue?vue&type=template&id=9f58ce2a&scoped=true"
import script from "./OrderChangeStatusDispatched.vue?vue&type=script&lang=js"
export * from "./OrderChangeStatusDispatched.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f58ce2a",
  null
  
)

export default component.exports